import {
  allIsFalse,
  DEFAULT_VALID,
  DEFAULT_VALIDATION_MODEL,
  requiredIsValid,
  ValidationModel,
} from 'helpers/utils/ValidationUtils';

export type VideoAssemblyValidatorType = {
  urlIsValid: () => ValidationModel;
  allIsValid: () => boolean;
};

export const VideoAssemblyValidator = (description: string, url: string) => {
  const validator: Partial<VideoAssemblyValidatorType> = {};

  validator.urlIsValid = () => {
    const regex =
      /(https?:\/\/)(www\.)?(youtube\.com\/(watch\?v=|live\/)([a-zA-Z0-9_-]{11})|youtu\.be\/([a-zA-Z0-9_-]{11})|m\.youtube\.com\/(watch\?v=|live\/)([a-zA-Z0-9_-]{11}))|https?:\/\/(www\.)?vimeo\.com\/([0-9]{9})/g;
    const value = url;
    const required = requiredIsValid(value, 'URL do vídeo é obrigatório');

    if (required.error) {
      return required;
    }

    if (!regex.test(value)) {
      return DEFAULT_VALIDATION_MODEL(true, 'O link não é do YouTube ou Vimeo');
    }

    return DEFAULT_VALID;
  };

  validator.allIsValid = () => {
    return allIsFalse([validator?.urlIsValid!().error]);
  };

  return validator as VideoAssemblyValidatorType;
};
